<div class="main-page-area">
    <div class="main-page-content">
        <eff-step-header
            id="testing-completed"
            [controlGuid]="effectivenessModel.controlGuid"
            [title]="'effWorkflowSteps.completed' | t"
            [saveButtonLabel]="'effStepHeader.reopen' | t"
            [hideSaveButton]="hideReopenButton()"
            (onSaveChanges)="reopenTestPlan()"
            [showNonOccurrenceWarningArea]="isNonOccurrence"
        >
        </eff-step-header>

        <div class="d-flex flex-column grid-conclusion-wrapper">
            <eff-detail-final-conclusion
                [effectivenessModel]="effectivenessModel"
            ></eff-detail-final-conclusion>
            <div class="d-flex flex-column">
                <eff-checkbox
                    class="expand-collapse-all"
                    [label]="'effGrid.openAll' | t"
                    (modelChange)="expandCollapseAll($event)"
                ></eff-checkbox>
                <div class="main-grid d-flex flex-column">
                    @for (viewSample of viewSamples; track viewSample) {
                        <div>
                            <div class="grid-header">
                                <div class="bold-text">{{ 'effGrid.sampleLabel' | t: { name: viewSample.sample.name } }}</div>
                                <eff-inline-text-editor
                                    [label]="'effGrid.addSampleRemark' | t"
                                    [(model)]="viewSample.sample.remarks"
                                    [disabled]="!stepPermissions.isEditSampleRemarkAllowed"
                                    (complete)="saveRemarksChange(viewSample.sample)"
                                ></eff-inline-text-editor>
                                @if (viewSample.sample.taskData) {
                                    <div
                                        class="task-link-label"
                                        (click)="openTask(viewSample.sample.taskData)"
                                    >
                                        <i class="fas fa-regular fa-link-horizontal"></i>
                                        <label>
                                            {{
                                                viewSample.sample.taskData.actionDate | dateFormat
                                            }}</label
                                        >
                                    </div>
                                }
                            </div>
                            <eff-table
                                [dataSource]="viewSample.gridDataSource"
                                [columns]="displayedColumns"
                                [tableConfig]="tableConfig"
                                [expandedRowTemplate]="expandedTemplate"
                            >
                                <ng-template #expandedTemplate let-item="item">
                                    <div class="grid-expanded-row">
                                        <div class="table-row">
                                            <div class="table-cell documents">
                                                <div class="d-flex flex-column gap-3">
                                                    @if (item.noEvidence) {
                                                        <div class="d-flex flex-column gap-2">
                                                            <eff-checkbox
                                                                [disabled]="true"
                                                                [checked]="true"
                                                                [label]="'effGrid.noEvidence' | t"
                                                            ></eff-checkbox>
                                                            <div class="no-evidence-inner">
                                                                <eff-textarea
                                                                    class="grid-textarea-style"
                                                                    [(model)]="
                                                                        item.noEvidenceReason
                                                                    "
                                                                    [bordered]="false"
                                                                    [disabled]="true"
                                                                    uiid="no-evidence"
                                                                    [popupTitle]="'effGrid.commentNoEvidence' | t"
                                                                ></eff-textarea>
                                                            </div>
                                                        </div>
                                                    }
                                                    <documents-list
                                                        class="documets-list-small-droparea"
                                                        [documents]="item.documents"
                                                        [canAdd]="false"
                                                        [canEdit]="false"
                                                        [canDelete]="false"
                                                        [taskDocuments]="item.taskData?.documents"
                                                        [isSample]="item.isSample"
                                                    ></documents-list>
                                                </div>
                                            </div>
                                            <div class="table-cell tester-comment">
                                                <div class="comment">
                                                    <eff-textarea
                                                        class="grid-textarea-style"
                                                        [(model)]="item.commentTester"
                                                        [bordered]="false"
                                                        [disabled]="true"
                                                        uiid="tester-comment"
                                                        [popupTitle]="'effGrid.commentTester' | t"
                                                    ></eff-textarea>
                                                </div>
                                            </div>
                                            @if (showReviewColumn) {
                                                <div class="table-cell reviewer-comment">
                                                    <div class="comment">
                                                        <eff-textarea
                                                            class="grid-textarea-style"
                                                            [(model)]="item.commentReviewer"
                                                            [bordered]="false"
                                                            [disabled]="true"
                                                            uiid="reviewer-comment"
                                                            [popupTitle]="'effGrid.commentReviewer' | t"
                                                        ></eff-textarea>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        @if (item.isLateTask) {
                                            <div class="sample-warning completed-later">
                                                <div class="sample-later-warning-text">
                                                    {{ 'effTestingCompleted.controlExecutionLateWarning' | t }}
                                                </div>
                                                <div
                                                    class="sample-later-warning-text padding-top-8"
                                                >
                                                    {{
                                                        'effGrid.controlExecutionCompletedAt'
                                                        | t: { date: (item.taskData.completedAt | dateTimeFormat) }
                                                    }}
                                                </div>
                                            </div>
                                        }
                                        @if (item.isOpenTask) {
                                            <div class="sample-warning not-completed">
                                                <div class="sample-not-completed-warning-text">
                                                    {{ 'effTestingCompleted.controlExecutionNotFinishedWarning' | t }}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </ng-template>
                                <ng-template column-name="name" let-item="item">
                                    <div class="d-flex flex-row gap-3 align-items-center">
                                        <div
                                            [ngClass]="{ 'sample-name-cell': item.isSample }"
                                            class="regular-text"
                                        >
                                            {{ (item.isSample ? 'effTestingCompleted.sample' : 'effTestingCompleted.step') | t }} {{ item.name }}
                                        </div>
                                        @if (totalDocumentCount(item) > 0) {
                                            <div class="d-flex flex-row align-items-center gap-1">
                                                <eff-icon
                                                    class="remark-icon"
                                                    icon="attachment_outlined"
                                                ></eff-icon>
                                                <div>({{ totalDocumentCount(item) }})</div>
                                            </div>
                                        }
                                    </div>
                                </ng-template>
                                <ng-template column-name="scoreTester" let-item="item">
                                    <div class="d-flex flex-row align-items-center status-cell">
                                        <div
                                            class="status-bullet"
                                            [ngClass]="getScoreColor(item)"
                                        ></div>
                                        <div>{{ item.scoreName }}</div>
                                    </div>
                                </ng-template>
                                <ng-template column-name="testerComment" let-item="item">
                                    @if (!item.IsExpanded && item.commentTester) {
                                        <div>
                                            <eff-icon
                                                class="remark-icon"
                                                icon="comment_outlined"
                                            ></eff-icon>
                                        </div>
                                    }
                                </ng-template>
                                <ng-template column-name="reviewerComment" let-item="item">
                                    @if (!item.IsExpanded && item.commentReviewer) {
                                        <div>
                                            <eff-icon
                                                class="remark-icon"
                                                icon="comment_outlined"
                                            ></eff-icon>
                                        </div>
                                    }
                                </ng-template>
                            </eff-table>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="side-page-area">
        @if (samples && effectivenessModel) {
            <eff-test-instructions-info-box
                [samples]="samples"
                [effectivenessModel]="effectivenessModel"
                [showEvidenceUploadInstructions]="true"
            >
            </eff-test-instructions-info-box>
        }
        <eff-evidence-instructions-info-box
            [samples]="samples"
            [instructions]="effectivenessModel.evidenceUploadInstructions"
        ></eff-evidence-instructions-info-box>
        <eff-source-document-info-box
            [effectivenessModel]="effectivenessModel"
            [stepPermissions]="stepPermissions"
        ></eff-source-document-info-box>
        <eff-control-info-box
            [controlGuid]="effectivenessModel.controlGuid"
            [effectivenessGuid]="effectivenessModel.guid"
            [testingCompleted]="true"
        ></eff-control-info-box>
    </div>
</div>
